import { render, staticRenderFns } from "./add_btn_dialog.vue?vue&type=template&id=6910e4da&scoped=true"
import script from "./add_btn_dialog.vue?vue&type=script&lang=js"
export * from "./add_btn_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910e4da",
  null
  
)

export default component.exports